<template>
  <div class="top-container overflow-hidden d-flex flex-column min-vh-100 position-relative">
    <Header class="flex-grow-0" />
    <div class="flex-grow-1 position-relative app-content">
      <div class="position-absolute w-100 h-100 d-flex align-items-center justify-content-center loader-content">
        <Loader :visible="itsLoading"></Loader>
      </div>
      <div class="bg-default z-2 position-relative">
        <router-view :key="$route.path" />
      </div>
    </div>
    <Footer class="flex-grow-0" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Header from './components/Header';
import Footer from './components/Footer';
import Loader from './components/Loader';

export default {
  name: 'app',
  components: {
    Header,
    Footer,
    Loader,
  },
  computed: {
    ...mapGetters(['affiliateIsAuthenticated', 'itsLoading']),
  },
  methods: {
    insertUOLTagManager() {
      const uvar = window.universal_variable || {};
      uvar.dfp = uvar.dfp || {};
      window.universal_variable = uvar;
      window.uolads = window.uolads || [];

      const script = document.createElement('script');
      script.src = '//tm.jsuol.com.br/uoltm.js?id=uyemlh';
      script.async = true;

      const head = document.querySelector('head');
      head.appendChild(script);
    },
    ...mapActions([
      'fetchAffiliateData',
      'loadEnabledFeatures',
      'getBlockedUrls',
      'getItsOnMaintenance',
    ]),
    loadAffiliateData() {
      const unwatch = this.$watch(
        'affiliateIsAuthenticated',
        async (affiliateIsAuthenticated) => {
          try {
            if (affiliateIsAuthenticated) {
              await this.fetchAffiliateData();
              unwatch();
            }
          } catch (error) {
            window.location.href = 'https://afiliados.uol.com.br/errorPage.html';
            throw error;
          }
        },
      );
    },
  },
  async created() {
    this.loadAffiliateData();
    this.insertUOLTagManager();
    await this.loadEnabledFeatures();
    await this.getBlockedUrls();
    await this.getItsOnMaintenance();
  },
};
</script>

<style lang="scss">
#app {
  font-family: $font-1;
  @include text-size-regular();
  color: $text-dark;
  background-color: $bg-default;
  -webkit-print-color-adjust: exact;

  @page {
    size: auto;
    margin: 5mm;
  }
}
.app-content {
  min-height: 100vh;
  @media screen and (min-width: $lg) {
    min-height: 80vh;
  }
}
</style>
